export class LoadFileModel {  
  archivoB64: string = "";
  nombreArchivo: string = "";
  categoriaArchivo: number=0;
  idUsuario: number=0;

  constructor() {
   
  }

}
